import { useMediaQuery } from './useMediaQuery';

/**
 * Hook to detect if the viewport is mobile size
 * Mobile: < 768px (matches Tailwind's md breakpoint)
 * @returns {boolean} - True if viewport is mobile size
 */
export const useIsMobile = () => {
  return useMediaQuery('(max-width: 767px)');
};

export default useIsMobile;

